import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const TranslateInCountry = ({ code }) => <FormattedMessage id={`in-${code}`} />;

TranslateInCountry.propTypes = {
  code: PropTypes.string.isRequired,
};

export default TranslateInCountry;
